import React from "react";
import logo from "../images/logo.jpg";

const Header = ({ setCurrentColor }) => {
  return (
    <div className="base-wrapper flex items-center justify-between py-[20px] md:py-[36px]">
      <div className="w-[50px] h-[55px]">
        <img src={logo} alt="" className="w-[50px] h-[55px]" />
      </div>
      <div className="hidden lg:flex gap-[62px]">
        <div className="text-[#8d8d8d] text-[19px] font-[500] uppercase cursor-pointer">
          <a href="/">Home</a>
        </div>
        <div className="text-[#8d8d8d] text-[19px] font-[500] uppercase cursor-pointer">
          <a href="#about">About me</a>
        </div>
        <div className="text-[#8d8d8d] text-[19px] font-[500] uppercase cursor-pointer">
          <a href="#team">Team</a>
        </div>
        <div className="text-[#8d8d8d] text-[19px] font-[500] uppercase cursor-pointer">
          <a href="#contact">contact</a>
        </div>
      </div>
      <div className="flex items-center gap-[11px]">
        <div
          className="w-[20px] h-[20px] md:w-[30px] md:h-[30px] rounded-full cursor-pointer bg-[#AEB049]"
          onClick={() => setCurrentColor("yellow")}
        ></div>
        <div
          className="w-[20px] h-[20px] md:w-[30px] md:h-[30px] rounded-full cursor-pointer bg-[#E02EF0]"
          onClick={() => setCurrentColor("pink")}
        ></div>
        <div
          className="w-[20px] h-[20px] md:w-[30px] md:h-[30px] rounded-full cursor-pointer bg-[#01C738]"
          onClick={() => setCurrentColor("green")}
        ></div>
        <div
          className="w-[20px] h-[20px] md:w-[30px] md:h-[30px] rounded-full cursor-pointer bg-[#FFFFFF]"
          onClick={() => setCurrentColor("white")}
        ></div>
        <div
          className="w-[20px] h-[20px] md:w-[30px] md:h-[30px] rounded-full cursor-pointer bg-[#EA5602]"
          onClick={() => setCurrentColor("orange")}
        ></div>
      </div>
    </div>
  );
};

export default Header;
